import { ValidatorFn, AbstractControl } from '@angular/forms';

export function amountPaidValidator(totalCostValue: number, prepayment: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const value = control.value;

        // 1. amountPaidControl не может быть больше, чем сумма this.totalCostValue - prepayment
        if (value.toFixed(2) > (totalCostValue - prepayment).toFixed(2)) {
            return { amountPaidExceedsTotal: true };
        }

        return null;
    };
}
